export const IOS_APP_STORE = "https://apps.apple.com/cn/app/id1054598922";

export const ANDROID_MARKET_FALLBACK =
  "https://a.app.qq.com/o/simple.jsp?pkgname=com.mcdonalds.gma.cn";

export const PAGE_TITLE = "奶昔大哥看球中";

/** 分享 H5 主视觉切图 */
export const SHARE_H5_BG_IMG = "https://img.mcd.cn/gallery/79fbab2b62a0231c.png";

/** 打开看看 / 底部 CTA 按钮切图 */
export const SHARE_H5_BTN_IMG = "https://img.mcd.cn/gallery/90fb6a07f916fcaa.png";

/** 推荐餐品模块背景（与弹幕区底对齐，右侧留白由样式控制） */
export const RECOMMEND_MEAL_CARD_BG = "https://img.mcd.cn/gallery/6bdf7ecb12d05f4a.png";

export const SHARE_GUIDE_TEXT =
  "我在和奶昔大哥一起看球，竞猜世界杯还有机会赢多种豪礼，你也来试试吧～";

export const OPEN_BTN_IMG_URL = 'https://img.mcd.cn/gallery/da275f1746485147.png'

export const BOTTOM_CTA_TEXT = "去麦当劳App 看奶昔大哥直播";

/** 呼起 App RN 直播间（FifaMatchLive），三端页名与原生约定一致 */
const LIVE_DEEPLINK =
  "mcdapp://page?iosPageName=MCDReactNativeViewController&androidPageName=com.mcd.library.rn.McdReactNativeActivity&harmonyPageName=RNPage&parameters=" +
  encodeURIComponent(
    JSON.stringify({
      rctModule: "campaign",
      rctModuleName: "FifaMatchLive",
      rctModuleParams: { showBg: "true" },
    })
  );

export const APP_OPEN = {
  liveExtInfo: LIVE_DEEPLINK,
};

export type DanmakuPoolItem = {
  nickname: string;
  content: string;
  avatar?: string;
};

export type DanmakuItem = DanmakuPoolItem & {
  avatar: string;
};

export const DANMAKU_AVATARS = [
  "https://img.mcd.cn/gallery/eb11e654d451c20e.png",
  "https://img.mcd.cn/gallery/199a6d809c6a7bc5.png",
  "https://img.mcd.cn/gallery/874a484f62812ea3.png",
  "https://img.mcd.cn/gallery/1bee234362e6d44d.png",
];

/** 欢迎语弹幕池（昵称 + 来了），头像由 pickRandomDanmaku 随机分配 */
export const MOCK_DANMAKU_POOL: DanmakuPoolItem[] = [
  { nickname: "扭**棒", content: "来了" },
  { nickname: "麦**多", content: "来了" },
  { nickname: "薯**子", content: "来了" },
  { nickname: "粉**会", content: "来了" },
  { nickname: "星**光", content: "来了" },
  { nickname: "汉**宝", content: "来了" },
  { nickname: "可**乐", content: "来了" },
  { nickname: "甜**筒", content: "来了" },
  { nickname: "金**门", content: "来了" },
  { nickname: "麦**旋", content: "来了" },
  { nickname: "脆**鸡", content: "来了" },
  { nickname: "大**叔", content: "来了" },
  { nickname: "奶**昔", content: "来了" },
  { nickname: "双**层", content: "来了" },
  { nickname: "小**薯", content: "来了" },
  { nickname: "安**斯", content: "来了" },
  { nickname: "麦**辣", content: "来了" },
  { nickname: "芝**士", content: "来了" },
  { nickname: "板**烧", content: "来了" },
  { nickname: "麦**啡", content: "来了" },
  { nickname: "麦*", content: "来了" },
  { nickname: "麦**罗", content: "来了" },
  { nickname: "朱**力", content: "来了" },
  { nickname: "麦**乐", content: "来了" },
  { nickname: "青**椒", content: "来了" },
  { nickname: "甜**酱", content: "来了" },
  { nickname: "麦**小", content: "来了" },
  { nickname: "麦**文", content: "来了" },
  { nickname: "康**尼", content: "来了" },
  { nickname: "麦**西", content: "来了" },
];

export const DANMAKU_VISIBLE_COUNT = 4;

/** 直播间分享页视觉稿基准宽度 */
export const LIVE_SHARE_DESIGN_WIDTH = 393;
